/** Shared offline copy — keep out of React hooks so QueryClient can import it. */

/** Toast / mutation guard — explicit: changes only when back online. */
export const OFFLINE_MSG =
  "Jelenleg offline vagy: módosítás (mentés, létrehozás, törlés) csak online elérhető. Kapcsolódj újra a hálózathoz.";

/** AppShell banner — kiadás/napló/fotó outboxba kerülhet. */
export const OFFLINE_BANNER_MSG =
  "Offline mód: kiadás, napló és fotó a várólistára kerül, és online visszatéréskor szinkronizálódik. Egyéb módosítás csak internetkapcsolattal.";
